<template>
    <div>
        <el-dialog
            title="申请售后"
            :close-on-click-modal="false"
            :visible.sync="afterSales"
            width="30%"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="售后类型：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择售后类型" @change="changeType">
<!--                        <el-option label="仅退款" value="JUST_REFUND"></el-option>
                        <el-option label="申请退款" value="REFUND"></el-option>
                        <el-option label="退货退款" value="RETURN_REFUND"></el-option>
                        <el-option label="返修" value="REPAIR"></el-option>-->
                        <el-option v-for="type in typeList" :label="type.label" :key="type.value" :value="type.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="售后原因：" prop="reason">
                    <el-select v-model="ruleForm.reasonUuid" value-key="uuid" placeholder="请选择售后类型"
                               @change="changeReason">
                        <el-option v-for="reason in reasonList" :label="reason.name" :key="reason.uuid"
                                   :value="reason.uuid"></el-option>
                    </el-select>
                    <!--                    <el-input type="textarea" v-model="ruleForm.reason"></el-input>-->
                </el-form-item>
                <el-form-item label="退款金额：" prop="returnPrice" v-if="ruleForm.type !== 'REPAIR'">
                    <el-input-number v-model="ruleForm.returnPrice" :min="0" :max="maxReturnPrice"></el-input-number>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                    <el-button @click="(function(){clearForm;afterSales = false; })()">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import {getDictionaryItem, reApplyAfterSale, saveAfterSale} from "../../../utils/interface";

export default {
    name: "complaintsDialog",
    data() {
        return {
            afterSales: false,
            maxReturnPrice:0,
            ruleForm: {
                uuid: "",
                type: "",
                reasonUuid: "",
                reason: "",
                returnMoney: '',
                orderBaseUuid: "",
                sellerUuid: "",
                seller: "",
                returnPrice:"",
            },
            fileList: [],
            typeList: [
                {
                    value: 'JUST_REFUND',
                    label: '仅退款'
                },
                {
                    value: 'REFUND',
                    label: '申请退款'
                },
                {
                    value: 'RETURN_REFUND',
                    label: '退货退款'
                },
                {
                    value: 'REPAIR',
                    label: '返修'
                }
            ],
            reasonList: [],
            rules: {
                type: [
                    {
                        required: true,
                        message: "请选择售后类型",
                        trigger: "change",
                    },
                ],
                reasonUuid: [
                    {
                        required: true,
                        message: "请选择售后原因",
                        trigger: "blur",
                    },
                ],
                returnPrice: [
                    {
                        required: true,
                        message: "请填写退款金额",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.changeDictList();
    },
    methods: {
        init(orderBaseUuid, sellerUuid, seller, orderType, orderStatus, orderPrice) {
            this.afterSales = true;
            this.ruleForm.orderBaseUuid = orderBaseUuid;
            this.ruleForm.sellerUuid = sellerUuid;
            this.ruleForm.seller = seller;
            this.ruleForm.returnPrice = orderPrice;
            this.maxReturnPrice = orderPrice;
            this.clearForm();
            this.typeList = [];
            if(orderType === 'PRINT') {
                if(orderStatus === 'UN_SEND') {
                    this.typeList.push({
                        value: 'JUST_REFUND',
                        label: '仅退款'
                    });
                }
                else if(orderStatus === 'UN_RECEIVE') {
                    this.typeList.push({
                        value: 'JUST_REFUND',
                        label: '仅退款'
                    });
                    this.typeList.push({
                        value: 'REPAIR',
                        label: '返修'
                    });
                }
                else if(orderStatus === 'UN_APPRAISE') {
                    this.typeList.push({
                        value: 'REPAIR',
                        label: '返修'
                    });
                }
                else if(orderStatus === 'FINISHED') {
                    this.typeList.push({
                        value: 'REPAIR',
                        label: '返修'
                    });
                }
            }
            if(orderType === 'SHOP') {
                if(orderStatus === 'UN_SEND') {
                    this.typeList.push({
                        value: 'JUST_REFUND',
                        label: '仅退款'
                    });
                }
                else if(orderStatus === 'UN_RECEIVE') {
                    this.typeList.push({
                        value: 'JUST_REFUND',
                        label: '仅退款'
                    });
                    this.typeList.push({
                        value: 'RETURN_REFUND',
                        label: '退货退款'
                    });
                }
                else if(orderStatus === 'UN_APPRAISE') {
                    this.typeList.push({
                        value: 'RETURN_REFUND',
                        label: '退货退款'
                    });
                }
                else if(orderStatus === 'FINISHED') {
                    this.typeList.push({
                        value: 'RETURN_REFUND',
                        label: '退货退款'
                    });
                }
            }
            if(orderType === 'SERVICE') {
                this.typeList.push({
                    value: 'REFUND',
                    label: '申请退款'
                });
            }
            if(orderType === 'DESIGN') {
                this.typeList.push({
                    value: 'REFUND',
                    label: '申请退款'
                });
            }
        },
        reApply(uuid, orderType) {
            this.ruleForm.uuid = uuid;
            this.afterSales = true;
            this.typeList = [];
            if(orderType === 'PRINT') {
                this.typeList.push({
                    value: 'JUST_REFUND',
                    label: '仅退款'
                });
                this.typeList.push({
                    value: 'REPAIR',
                    label: '返修'
                });
            }
            if(orderType === 'SERVICE') {
                this.typeList.push({
                    value: 'JUST_REFUND',
                    label: '仅退款'
                });
            }
            if(orderType === 'DESIGN') {
                this.typeList.push({
                    value: 'REFUND',
                    label: '申请退款'
                });
            }
        },
        changeType() {
            this.ruleForm.reasonUuid = "";
            this.ruleForm.reason = "";
            this.ruleForm.returnMoney = "";
            this.changeDictList();
        },
        clearForm() {
            this.ruleForm.type = "";
            this.ruleForm.reasonUuid = "";
            this.ruleForm.reason = "";
            this.ruleForm.returnMoney = "";
        },
        changeReason(reason) {
            this.reasonList.find(item => {
                if (item.uuid === reason) {
                    this.ruleForm.reasonUuid = item.uuid;
                    this.ruleForm.reason = item.name;
                }
            })

        },
        changeDictList() {
            getDictionaryItem({groupCode: this.ruleForm.type}).then((res) => {
                this.reasonList = [];
                res.forEach((item, index) => {
                    this.reasonList.push({
                        uuid: item.uuid,
                        name: item.name,
                        code: item.code,
                        groupUuid: item.groupUuid
                    });
                });
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.ruleForm.uuid) {
                        reApplyAfterSale(this.ruleForm).then((response) => {
                            if (response.success) {
                                this.$message({
                                    type: "success",
                                    message: "售后申请重新提交成功",
                                    duration: 1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                                    onClose: () => {
                                        //跳转页面或执行方法
                                        this.$router.go(0);
                                    }
                                });
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.message,
                                });
                            }
                            this.afterSales = false;
                        });
                    } else {
                        saveAfterSale(this.ruleForm).then((response) => {
                            if (response.success) {
                                this.$message({
                                    type: "success",
                                    message: "售后申请提交成功",
                                    duration: 1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                                    onClose: () => {
                                        //跳转页面或执行方法
                                        this.$router.go(0);
                                    }
                                });
                            } else {
                                this.$message({
                                    type: "error",
                                    message: response.message,
                                });
                            }
                            this.afterSales = false;
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/afterSalesDialog.vue